import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import { color } from 'framer-motion';
import { CopyBlock, dracula } from "react-code-blocks";


const JavaScriptLesson30 = () => {
  const [language, changeLanguage] = useState("javascript");
  const [lineNumbers, toggleLineNumbers] = useState(false);
  const code = (
  'text',
  `
  let str = "Hello, World!";
  console.log(str.length); // Output: 13
  `
  );
  const code2 = (
  'text',
  `
  let str = "Hello, World!";
  console.log(str.charAt(0)); // Output: "H"
  console.log(str.charCodeAt(1)); // Output: 101 (Unicode value of "e")
  `
  );
  const code3 = (
  'text',
  `
  let str = "Hello, World!";
  console.log(str.substring(0, 5)); // Output: "Hello"
  console.log(str.substr(7, 5)); // Output: "World"
  console.log(str.slice(7)); // Output: "World!"
  `
  );
  const code4 = (
  'text',
  `
  let str = "Hello, World!";
  console.log(str.toUpperCase()); // Output: "HELLO, WORLD!"
  console.log(str.toLowerCase()); // Output: "hello, world!"
  `
  );
  const code5 = (
  'text',
  `
  let str = "Hello, World!";
  console.log(str.indexOf("World")); // Output: 7
  console.log(str.includes("Hello")); // Output: true
  console.log(str.replace("World", "Universe")); // Output: "Hello, Universe!"
  `
  );
  const code6 = (
  'text',
  `
  let str = "   Hello, World!   ";
  console.log(str.trim()); // Output: "Hello, World!"
  `
  );

  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">
    <h3><strong>String Methods</strong></h3>
    <p> Strings are primitive data types that represent sequences of characters. JavaScript provides a variety of built-in string methods that allow you to manipulate and perform operations on strings.</p>
    <p>These methods enable you to work with strings effectively, including manipulating their content, searching for substrings, and performing transformations. Let's explore some commonly used string methods in JavaScript:</p>
    <div className="alert alert-secondary" role="alert">
    <h4><strong>1. String Length</strong></h4>
    <p>length: Returns the length of a string, which is the number of characters it contains.</p>
    <CopyBlock
    language={language}
    text={code}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>2. Accessing Characters</strong></h4>
    <ul>
    <li>charAt(index): Returns the character at the specified index in the string.</li>
    <li>charCodeAt(index): Returns the Unicode value of the character at the specified index.</li>
    </ul>
    <CopyBlock
    language={language}
    text={code2}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>3. Substring Extraction</strong></h4>
    <ul>
    <li>substring(startIndex, endIndex): Returns a substring from the specified start index to the specified end index (excluding the end index).</li>
    <li>substr(startIndex, length): Returns a substring starting from the specified start index with the specified length.</li>
    <li>slice(startIndex, endIndex): Returns a portion of a string between the specified start index and end index (excluding the end index).</li>
    </ul>
    <CopyBlock
    language={language}
    text={code3}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>4. Case Conversion</strong></h4>
    <ul>
    <li>toUpperCase(): Converts a string to uppercase.</li>
    <li>toLowerCase(): Converts a string to lowercase.</li>
    </ul>
    <CopyBlock
    language={language}
    text={code4}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>5. Searching and Replacing</strong></h4>
    <ul>
    <li>indexOf(substring): Returns the index of the first occurrence of the specified substring in the string (-1 if not found).</li>
    <li>lastIndexOf(substring): Returns the index of the last occurrence of the specified substring in the string (-1 if not found).</li>
    <li>includes(substring): Returns true if the string contains the specified substring, otherwise false.</li>
    <li>replace(oldValue, newValue): Replaces occurrences of a specified value with another value.</li>
    </ul>
    <CopyBlock
    language={language}
    text={code5}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    <div className="alert alert-secondary" role="alert">
    <h4><strong>6. Trimming Whitespace</strong></h4>
    <p>trim(): Removes whitespace from both ends of the string. <br /> It can be useful in sanitizing user inputs before sending them off to the database with password being the only exception. You want to restrict sanitation on user passwords because you don't know if whitespace is part of the password characters.</p>
    <CopyBlock
    language={language}
    text={code6}
    showLineNumbers={lineNumbers}
    theme={dracula}
    wrapLines={true}
    codeBlock
    />
    </div>

    </div>
    </div>
    </div>
    </HTMLCourseNavProvider>
  )
}

export default JavaScriptLesson30
